<template>
<div>
  <template>
    <arksnackbar v-model="status"></arksnackbar>
    <loader v-model=status.loading></loader>
    <confirm ref="confirm"></confirm>
  </template>
  <customdialog v-model="dialog" title="Fatura Viewer" :cardtextstyle="'height: 760px;'">

    <!--<pre><code> <span id="demo"></span></code></pre>-->
    <div id="demo"></div>

    <reportbrosablon ref="reportbrosablon" v-model="FaturaPdfID"
    dizayngrupadi="Fatura" objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>
    <v-btn color="primary" flat @click.native="ReportBroYazdir()"> {{ $t('Report-Bro-Print') }} </v-btn>
    <v-text-field label="FaturaPdfID" v-model="FaturaPdfID" ></v-text-field>

    <template slot="btn">
      <v-btn color="primary" flat @click.native="EFaturaGonder()"> {{ $t('Send-Invoice') }} </v-btn>
      <v-btn color="primary" flat @click.native="DialogShowManuelNoVer(1)"> {{ $t('Enter-Manual-No') }} </v-btn>
      <v-btn color="primary" flat @click.native="DialogShowManuelNoVer(2)"> {{ $t('Enter-Approval-Invoice') }} </v-btn>
      <v-btn color="primary" flat @click.native="KesinBasariliIsaretle()"> {{ $t('Mark-Certain-Success') }} </v-btn>
      <v-btn color="primary" flat @click.native="FaturaIptal()"> {{ $t('Cancel-Invoice') }}  </v-btn>
      <v-btn color="primary" flat @click.native="FaturaSil()">  {{ $t('Delete-Invoice') }} </v-btn>
    </template>

  </customdialog>

  <customdialog v-model="dialogManuel" :title="$t('Enter-Manual-No')" maxWidth=600px :cardtextstyle="'height: 350px;'">
    {{ $t('Proforma-No') }} : {{FaturaIcerik.Fatura.seriYilNo}}
    <br>
    {{ $t('Proforma-Date') }} : {{FaturaIcerik.Fatura.tarih}}

    <v-layout>
      <v-text-field :label="$t('GIB-Invoice-Date')" v-model="YeniFatura.tarih" type="datetime-local"></v-text-field>
      <v-text-field :label="$t('GIB-Invoice-Serial')" v-model="YeniFatura.seri" maxlength=3></v-text-field>
      <v-text-field :label="$t('GIB-Invoice-No')" v-model="YeniFatura.no" type="number" maxlength=9 min="1" max="999999999"></v-text-field>
    </v-layout>

    <template slot="btn">
      <v-btn color="primary" flat @click.native="ManuelNoVer()"> {{ $t('Enter-Manual-No') }} </v-btn>
    </template>
  </customdialog>

</div>
</template>

<script>
import customdialog from "@/components/app/coper/comp/customdialog.vue";
import tool from "../coper/tools";
import loader from "@/components/app/coper/comp/loader.vue";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";
import confirm from "@/components/app/coper/comp/confirm.vue";
import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";

export default {
  data() {
    return {

      FaturaPdfID:0,

      status: tool.NewSatatus(),
      dialog: false,
      dialogManuel: false,
      resolve: null,
      reject: null,

      prm: null,
      tip: 0,
      FaturaNoTip: 0,
      options: {
        color: "primary",
        width: 380,
      },
      FaturaIcerik: {
        Fatura: {
          seri: "",
          tarih: "",
          no: "",
        },
      },
      YeniFatura: {
        seri: "",
        tarih: "",
        no: 0,
      },

    };
  },
  components: {
    customdialog,
    loader,
    arksnackbar,
    confirm,
    reportbrosablon,
  },
  methods: {
    FaturaShow: FaturaShow,
    EFaturaGonder: EFaturaGonder,
    ManuelNoVer: ManuelNoVer,
    FaturaNoVer: FaturaNoVer,

    DialogShowManuelNoVer: DialogShowManuelNoVer,
    KesinBasariliIsaretle: KesinBasariliIsaretle,
    FaturaIptal: FaturaIptal,
    FaturaSil: FaturaSil,

  ReportBroYazdir: ReportBroYazdir,

    open(prm, tip) {
      this.dialog = true;
      this.prm = prm;
      this.tip = tip;
      this.FaturaShow(prm);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    yes() {
      this.resolve(this.inputvalue);
      this.dialog = false;
    },
    cancel() {
      this.resolve(null);
      this.dialog = false;
    }
  }
};

function FaturaShow(prm) {

  this.status.loading = true;
  tool.api_post(this, "EFatura/FaturaShow", prm).then(
    //tool.api_post(this, "EFatura/FaturaPDF", prm).then(
    response => {
      //this.items = response.body;

      document.getElementById("demo").innerHTML = response.body;
      //document.getElementById("demo").innerText = response.body;

      this.status.loading = false;
    },
    response => {
      this.status = tool.responseToStatus(response);

    }
  );

}


function ReportBroYazdir() {

  var prm = {
    id: this.prm.id,
    guid: this.prm.guid
  };
  this.status.loading = true;
  this.$refs.reportbrosablon.Print(prm,this.FaturaPdfID).then(
    confirm => {
      this.status.loading = false;
    },
    confirm => {
      this.status.loading = false;
    }
  );
}

function EFaturaGonder() {
  var prm = {
    faturaTip: this.tip,
    faturaList: [{
      id: this.prm.id,
      guid: this.prm.guid
    }]
  };

  this.status.loading = true;
  tool.api_post(this, "EFatura/EFaturaGonder", prm).then(
    response => {


      //document.getElementById("demo").innerHTML = response.body;
      this.$refs.confirm.messageShow("Gönderim Sonucu", response.body, {
        color: "primary",
        width: 780,
        message: null
      });

      this.status.loading = false;
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function DialogShowManuelNoVer(v) {

  this.FaturaNoTip = v;

  var prm = {
    id: this.prm.id,
    guid: this.prm.guid
  };

  this.status.loading = true;
  tool.api_post(this, "EFatura/GetFaturaIcerik", prm).then(
    response => {


      //document.getElementById("demo").innerHTML = response.body;
      this.FaturaIcerik = response.body;
      this.YeniFatura.tarih = this.FaturaIcerik.Fatura.tarih
      this.status.loading = false;
      this.dialogManuel = true;

    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function KesinBasariliIsaretle() {

  if (window.confirm(this.$t('process-will-mark-invoice-certain-success--Wish-Continue'))) {

    var prm = {
      id: this.prm.id,
      guid: this.prm.guid
    };

    this.status.loading = true;
    tool.api_post(this, "EFatura/KesinBasariliIsaretle", prm).then(
      response => {
        this.status.loading = false;

        this.$refs.confirm.messageShow("İşlem Sonucu", response.body, {
          color: "primary",
          width: 780,
          message: null
        });
      },
      response => {
        this.status = tool.responseToStatus(response);
      }
    );
  }

}

function FaturaSil() {

  if (window.confirm(this.$t('process-wont-delete-invoices-Arkman-Really-Wish-Continue'))) {

    var prm = {
      id: this.prm.id,
      guid: this.prm.guid
    };

    this.status.loading = true;
    tool.api_post(this, "EFatura/FaturaSil", prm).then(
      response => {
        this.status.loading = false;
        this.$refs.confirm.messageShow("İşlem Sonucu", response.body, {
          color: "primary",
          width: 780,
          message: null
        });

      },
      response => {
        this.status = tool.responseToStatus(response);
      }
    );
  }
}

function FaturaIptal() {

  if (window.confirm(this.$t('process-cancels-sent-invoice-Wish-Continue'))) {

    var prm = {
      id: this.prm.id,
      guid: this.prm.guid
    };

    this.status.loading = true;
    tool.api_post(this, "EFatura/FaturaIptal", prm).then(
      response => {
        this.status.loading = false;
        this.$refs.confirm.messageShow("İşlem Sonucu", response.body, {
          color: "primary",
          width: 780,
          message: null
        });

      },
      response => {
        this.status = tool.responseToStatus(response);

      }
    );

  }
}

function FaturaNoVer() {

  if (this.FaturaNoTip == 1) {
    this.ManuelNoVer();
  } else if (this.FaturaNoTip == 2) {
    this.OnayFaturaNoVer();
  }

}

function ManuelNoVer() {

  var prm = {
    FaturaId: {
      id: this.prm.id,
      guid: this.prm.guid
    },
    YeniFatura: this.YeniFatura
  };

  this.status.loading = true;
  tool.api_post(this, "EFatura/FaturaNoVer", prm).then(
    response => {

      this.status.loading = false;
      this.dialogManuel = false;
      this.$refs.confirm.messageShow("İşlem Sonucu", response.body, {
        color: "primary",
        width: 780,
        message: null
      });

    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );

}

function OnayFaturaNoVer() {

  var prm = {
    FaturaId: {
      id: this.prm.id,
      guid: this.prm.guid
    },
    YeniFatura: this.YeniFatura
  };

  this.status.loading = true;
  tool.api_post(this, "EFatura/OnayFaturaNoVer", prm).then(
    response => {

      this.status.loading = false;
      this.dialogManuel = false;
      this.$refs.confirm.messageShow("İşlem Sonucu", response.body, {
        color: "primary",
        width: 780,
        message: null
      });

    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );

}
</script>
